import { ErrorResponseInterface } from '@systemeio/util'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { baseFetcher } from 'shared/utils/http-client'

export interface UseApplePayInterface {
  badRequestHandler?: (e: ErrorResponseInterface) => void
}

export interface UseApplePayDomains {
  shouldFetch?: boolean
}

export type ConnectApplePayDomainData = {
  hostName: string
}

export type ApplePayDomain = {
  host_name: string
  id: number
  enabled: boolean
}

export const useApplePayDomains = ({ shouldFetch }: UseApplePayDomains) => {
  const { data, mutate, isLoading } = useControlledSwr(
    '/api/dashboard/stripe/apple-pay/domains/show',
    baseFetcher,
    undefined,
    shouldFetch,
  )

  return { domainList: data, mutate, isLoading }
}

export const useApplePayActions = ({ badRequestHandler }: UseApplePayInterface = {}) => {
  const { fetcher } = useFetch<RequestMethodsEnum>({
    method: RequestMethodsEnum.post,
    badRequestHandler,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum>({
    method: RequestMethodsEnum.delete,
    badRequestHandler,
  })

  const connectDomain = (data: ConnectApplePayDomainData) =>
    fetcher('/api/dashboard/stripe/apple-pay/domain', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

  const disconnectDomain = (id: number) =>
    deleteFetcher(`/api/dashboard/stripe/apple-pay/domains/${id}`)

  return {
    connectDomain,
    disconnectDomain,
  }
}
